module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Mainstays',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
      country: 'COUNTRY',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Mainstays?',
      edit: 'Are you sure to edit this Mainstays?',
      enable: 'Are you sure you want to enable this Mainstays?',
      disable: 'Are you sure you want to disable this Mainstays?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image1x1: 'Please upload a 1x1 image',
    imageUpload: '*Upload an image',
    title: 'Title',
    subTitle: 'Subtitle',
    link: 'Link',
    linkType: 'Page Type',
    countries: 'Countries',
    btnUpdateMainstays: 'Update',
    btnCreateMainstays: 'Add',
    updateMainstays: 'Edit Mainstays',
    createMainstays: 'Add Mainstays',
    backgroundColor: 'Background Color',
    titleColor: 'Title Color',
    subColor: 'Subtitle Color',
    cta: 'CTA',
    ctaTextColor: 'CTA Text Color',
    category: 'Category',
    ctaBackgroundColor: 'CTA Background Color',
    ctaDeepLink: 'Feature App Deeplink',
  },
  validate: {
    titleBlank: 'Please input title!',
    countryBlank: 'Please select country!',
    linkBlank: 'Please input a link!',
    linkTypeBlank: 'Please select page type!',
    imageBlank: 'Please input an image!',
    categoryBlank: 'Please select category!',
    ctaBlank: 'Please input a CTA!',
    buttonList: 'Please input Button (All Mainstays) text!',
    buttonDetail: 'Please input Button (Mainstays Details) text!',
    ctaDeepLinkBlank: 'Please select a Feature App Deeplink!',
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image',
    },
    success: {
      updateMainstays: 'Mainstays successfully updated.',
      createMainstays: 'Mainstays successfully added.',
      deleteMainstays: 'Mainstays successfully deleted.',
    },
  },
};
